import { useState } from "react";
// import arrow from "../../Images/Icons/arrow.png";
import arrow from "../../Images/Icons/arrowdownwhite.png";
// import whatsapp from "../../Images/Icons/whatsapp.png";
import whatsapp from "../../Images/Icons/whatsappWhite.png";
import behance from "../../Images/Icons/behance.png"
import "./Ctabanner.css";
import { useNavigate } from "react-router-dom";
const Ctabanner = () => {
    const [mouse, setMouse] = useState(false);
    const [mouse2, setMouse2] = useState(false);

    function handleMouseIn() {
        setMouse(true);
    }
    function handleMouseOut() {
        setMouse(false);
    }

    const LinkTo = useNavigate();

    return (
        <>
            <div className="ctaBannerSec">
                <div className="allinone">
                    <div className="authorContactButtonsHero">
                        <button onClick={()=> LinkTo("https://wa.me/9816185204  ")} className={mouse ? "MouseIn" : "MouseOut"} onMouseEnter={handleMouseIn} onMouseLeave={handleMouseOut}>
                            <div className="btnBackPattern"></div>
                            <div className="text"><span>Lets Talk</span><span>Whatsapp</span></div>
                            <div className="icon"><img className="iamArrow" src={arrow} alt="arrow" /><img src={whatsapp} alt="" /></div>
                        </button>

                        <div onClick={()=> LinkTo("https://www.behance.net/bhanubhsapkota1")} onMouseEnter={() => setMouse2(true)} onMouseLeave={() => setMouse2(false)} className={mouse2 ? "btn btnIn" : "btn btnOut"}>
                            <div className="text"><span>View Work</span><span>Behance</span></div>
                            <div className="popIcon"><img src={behance} alt="" /></div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
export default Ctabanner;